import moment from "moment";
import React, { useEffect, useRef, useState } from "react";


function DateFormat(props) {
    return (
        <>
        {moment(props.date).format("MM-DD-YYYY, h:mm a")}
        </>
    )
}
export default DateFormat;